import { action, makeObservable, observable } from 'mobx';

import { platformInfo } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { PayloadType } from 'APP/model/message/messageModel.types';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { Payload } from '../Payload';

interface IE2eePayloadData {
  e2eePayload: ArrayBuffer;
  selfPayload?: ArrayBuffer;
  epoch: number;
  senderDeviceId: string;
  groupId: string;
  message?: ChatMessage;
  // ToDo: [E2EE] необходимо перевести Message и все payloads на ts и посмотреть, где летит неверный payload data
  e2eeData?: ArrayBuffer;
  selfData?: ArrayBuffer;
  text?: string;
}

export interface IE2eePayloadJson {
  e2eePayload: ArrayBuffer;
  selfPayload?: ArrayBuffer;
  epoch: number;
  senderDeviceId: string;
  payloadType: PayloadType;
  groupId: string;
  text?: string | null;
}

export class E2eePayload extends Payload {
  e2eeData: ArrayBuffer;
  selfData?: ArrayBuffer;
  senderDeviceId: string;
  groupId: string;
  epoch: number;
  @observable text: string | null = null;

  constructor(data: IE2eePayloadData) {
    super({ ...data, payloadType: PayloadType.E2ee });

    makeObservable(this);

    this.groupId = data.groupId || data.message?.groupId;
    this.epoch = data.epoch;
    this.senderDeviceId = data.senderDeviceId;
    this.e2eeData = data.e2eePayload || data.e2eeData;
    this.selfData = data.selfPayload || data.selfData;

    if (data.text) {
      this.text = data.text;
    }

    if (data.senderDeviceId === platformInfo.deviceId) {
      this.selfData && Tasks.e2ee.decodeSelfPayload(this.selfData, this.setDecodedText.bind(this));
    } else {
      Tasks.e2ee.checkEpochAndDecodePayload({
        groupId: this.groupId,
        e2eeData: this.e2eeData,
        epoch: this.epoch,
        callback: this.setDecodedText.bind(this),
      });
    }
  }

  toJSON(): IE2eePayloadJson {
    return {
      ...super.toJSON(),
      selfPayload: this.selfData,
      e2eePayload: this.e2eeData,
      epoch: this.epoch,
      senderDeviceId: this.senderDeviceId,
      groupId: this.groupId,
      text: this.text,
    };
  }

  @action setEpoch(epoch: number): void {
    this.epoch = epoch;
  }

  @action setDecodedText(decodedText: string): void {
    this.text = decodedText;
  }
}
